export default __webpack_public_path__ + "static/media/send.f267d4c3.svg";